'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'feather-pointed';
var width = 512;
var height = 512;
var aliases = ["feather-alt"];
var unicode = 'f56b';
var svgPathData = ['M113.7 275.1c-5.6 30.5-2.5 57.6 9.8 79.4l205.4-205.3 33.9 33.9-24.9 24.9 82.1 0c4.1-12 8-24.2 11.6-36.8 11.8-40.9 19.9-81.7 25.3-116.2-34.5 5.4-75.2 13.5-116.2 25.3-65.3 18.8-124.8 45-162.3 78.4l-7.2 6.8c-27.4 27.4-50.1 68.6-57.6 109.6zm43.8 113.3c21.8 12.3 48.8 15.5 79.4 9.9 35.2-6.5 70.4-24.1 97.1-46.3l-140 0-36.5 36.4zM241.9 304l133.4 0c9.3-14.4 17.9-30.6 25.8-48l-111.2 0-48 48z', 'M512 0c-6.9 83.7-40.5 283.5-131.6 374.6l-6.6 6.3c-64.2 59.2-175.8 95.1-251.1 42.2l-87.5 87.6-33.9-33.9 87.5-87.6c-52.9-75.3-16.9-186.9 42.3-251.1l6.3-6.6C228.5 40.5 428.3 6.9 512 0zM194 352l-36.5 36.4c21.8 12.3 48.8 15.5 79.4 9.9 35.2-6.5 70.4-24.1 97.1-46.3l-140 0zm263-296.9c-34.5 5.4-75.2 13.5-116.2 25.3-65.3 18.8-124.8 45-162.3 78.4l-7.2 6.8c-27.4 27.4-50.1 68.6-57.6 109.6-5.6 30.5-2.5 57.6 9.8 79.4l205.4-205.3 33.9 33.9-24.9 24.9 82.1 0c4.1-12 8-24.2 11.6-36.8 11.8-40.9 19.9-81.7 25.3-116.2zM289.9 256l-48 48 133.4 0c9.3-14.4 17.9-30.6 25.8-48l-111.2 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFeatherPointed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;